// src/components/button/BtnClearFilter.tsx

import { HighlightOffTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'

type BtnClearFilterProps = {
  onClick: () => void
}

export const BtnClearFilter = ({ onClick }: BtnClearFilterProps) => (
  <Tooltip title={'Filter löschen'}>
    <IconButton onClick={onClick}>
      <HighlightOffTwoTone />
    </IconButton>
  </Tooltip>
)
